export const PARTNERS = 'PARTNERS'
export const SET_PARTNERS = PARTNERS + '/SET_PARTNERS'
export const SET_CURRENT_PARTNER_CODE = PARTNERS + '/SET_CURRENT_PARTNER_CODE'
export const RESET_CURRENT_PARTNER_CODE = PARTNERS + '/RESET_CURRENT_PARTNER_CODE'
export const SET_FILTER_PARTNER = PARTNERS + '/SET_FILTER_PARTNER'
export const SET_HIDDEN_FILTER_PARTNERS = PARTNERS + '/SET_HIDDEN_FILTER_PARTNERS'
export const ADD_PARTNERS = PARTNERS + '/ADD_PARTNERS'
export const ON_OR_OFF_LOADER = PARTNERS + '/ON_OR_OFF_LOADER'
export const SET_CATEGORY_SEO_STATS = PARTNERS + '/SET_CATEGORY_SEO_STATS'
export const SET_LIST_SCOPE = PARTNERS + '/SET_LIST_SCOPE'
